import { formatInTimeZone } from 'date-fns-tz';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { JoveDateFormatTypeEnum, getDateFormat } from './date';
dayjs.extend(utc);

/**
 * date or time date transform to time show string
 * @param dateStr time date
 * @param param1 format
 * @returns
 */
export var transformDateStrToTimeString = function transformDateStrToTimeString(dateStr) {
  var _dayjs;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$format = _ref.format,
      format = _ref$format === void 0 ? 'YYYY-MM-DD HH:mm:ss' : _ref$format;

  if (!dateStr) return '';
  return (_dayjs = dayjs(dateStr)) === null || _dayjs === void 0 ? void 0 : _dayjs.format(format);
};
/**
 * format common use datestr
 * @param date
 * @returns
 */
// common: format to date

export var formatCommonDateStr = function formatCommonDateStr(date, config) {
  if (!date) return '';
  return transformDateStrToTimeString(date, {
    format: getDateFormat(config === null || config === void 0 ? void 0 : config.country, JoveDateFormatTypeEnum.DAYJS_UPPERCASE, {
      delimiter: '.'
    })
  });
};
/**
 * format common use datestr without timezone shift for ISO datetime strings
 * @param date
 * @returns
 */

export var formatCommonDateStrKeepDatePart = function formatCommonDateStrKeepDatePart(date, config) {
  if (!date) return '';

  if (typeof date === 'string') {
    var matchedDatePart = date.match(/^(\d{4}-\d{2}-\d{2})/);

    if (matchedDatePart !== null && matchedDatePart !== void 0 && matchedDatePart[1]) {
      return transformDateStrToTimeString(matchedDatePart[1], {
        format: getDateFormat(config === null || config === void 0 ? void 0 : config.country, JoveDateFormatTypeEnum.DAYJS_UPPERCASE, {
          delimiter: '.'
        })
      });
    }
  }

  return formatCommonDateStr(date, config);
};
/**
 * format common use datestr
 * @param date
 * @returns
 */
// common: format to date

export var formatCommonDateAndTimeStr = function formatCommonDateAndTimeStr(date) {
  if (!date) return '';
  return transformDateStrToTimeString(date, {
    format: 'DD.MMM.YYYY HH:mm:ss'
  });
};
/**
 * Calculate time between dates： minuendDate - subtrahendDate
 * @param minuendDate minuend
 * @param subtrahendDate subtrahend
 * @param param2 type: 1. days
 * @returns
 */

export var calculateTimeBetweenDates = function calculateTimeBetweenDates(minuendDate, subtrahendDate) {
  var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref2$type = _ref2.type,
      type = _ref2$type === void 0 ? 1 : _ref2$type;

  if (!minuendDate || !subtrahendDate) return 0; // Strip the time part by setting the time to 00:00:00

  var minuendDateOnly = dayjs(minuendDate).startOf('day');
  var subtrahendDateOnly = dayjs(subtrahendDate).startOf('day');
  var diffDays = minuendDateOnly.diff(subtrahendDateOnly, 'day');

  if (type === 2) {
    // will be implemented later if required
    return 0;
  } else {
    return diffDays;
  }
};
/**
 * judge who is front of the date with toady
 * @param haveDate judge date
 * @param param1 return date add day time
 * @returns
 */

export var calculateMinDateCompareToday = function calculateMinDateCompareToday(haveDate) {
  var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref3$addDay = _ref3.addDay,
      addDay = _ref3$addDay === void 0 ? 0 : _ref3$addDay;

  if (!haveDate) return dayjs(new Date());
  var haveTime = dayjs(haveDate).add(addDay, 'day');
  var today = dayjs(new Date()).add(addDay, 'day');
  return haveTime.isBefore(today) ? today : haveTime;
};
/**
 * judge date is earlier than a certain date
 * @param date
 * @param compareDate
 * @returns
 */

export var judgeWhetherIsEarlierThanTheDate = function judgeWhetherIsEarlierThanTheDate(date, compareDate) {
  if (!date || !compareDate) return false;
  return dayjs(date).isBefore(dayjs(compareDate));
};
/**
 * judge date is after than a certain date
 * @param date
 * @param compareDate
 * @returns
 */

export var judgeWhetherIsLaterThanTheDate = function judgeWhetherIsLaterThanTheDate(date, compareDate) {
  if (!date || !compareDate) return false;
  return dayjs(date).isAfter(dayjs(compareDate));
};
/**
 * judge date is same than a certain date
 * @param date
 * @param compareDate
 * @returns
 */

export var judgeWhetherIsSameThanTheDate = function judgeWhetherIsSameThanTheDate(date, compareDate) {
  if (!date || !compareDate) return false;
  return dayjs(date).isSame(dayjs(compareDate));
};
/**
 * judge date is between two dates
 * @param date
 * @param startDate start compare date
 * @param endDate end compare date
 * @returns
 */

export var judgeWhetherIsBetweenTwoDate = function judgeWhetherIsBetweenTwoDate(date, startDate, endDate) {
  if (!date || !startDate || !endDate) return false;
  return judgeWhetherIsEarlierThanTheDate(date, endDate) && judgeWhetherIsLaterThanTheDate(date, startDate) || judgeWhetherIsSameThanTheDate(date, startDate) || judgeWhetherIsSameThanTheDate(date, endDate);
};
export var getCurrentUserWebTimeZone = function getCurrentUserWebTimeZone() {
  var _Intl$DateTimeFormat$;

  var timeZone = (_Intl$DateTimeFormat$ = Intl.DateTimeFormat().resolvedOptions()) === null || _Intl$DateTimeFormat$ === void 0 ? void 0 : _Intl$DateTimeFormat$.timeZone;
  return !timeZone || timeZone === 'local' ? 'Europe/London' : timeZone;
};
/**
 * Converts time to time data stored by the server
 * @param date Date
 * @param config
 * @returns
 */

export var convertTimeToServerStoredTimeData = function convertTimeToServerStoredTimeData(date, config) {
  if (!date) return '';

  var _ref4 = config || {},
      _ref4$format = _ref4.format,
      format = _ref4$format === void 0 ? "yyyy-MM-dd'T'HH:mm:ssxxx" : _ref4$format;

  var formattedDateTime = undefined;

  try {
    // Get the time zone
    var userTimezone = getCurrentUserWebTimeZone(); // Format date

    formattedDateTime = formatInTimeZone(date, userTimezone, format);
  } catch (_) {}

  return formattedDateTime;
};
/**
 * Converts Dayjs time to time data stored by the server
 * @param date Date
 * @param config
 * @returns
 */

export var convertDayjsTimeToServerStoredTimeData = function convertDayjsTimeToServerStoredTimeData(date, config) {
  if (!date) return '';
  return convertTimeToServerStoredTimeData(dayjs(date).toDate(), config);
};
/**
 * Converts Dayjs time to time data stored by the server
 * @param date Date
 * @param config
 * @returns
 */

export var convertTimeToServerStoredTimeDataWithZeroTime = function convertTimeToServerStoredTimeDataWithZeroTime(date, config) {
  if (!date) return null;
  return convertTimeToServerStoredTimeData(dayjs(date).startOf('day').toDate(), config);
};
export var convertDayEndTimeToServerStoredTimeDataWithZeroTime = function convertDayEndTimeToServerStoredTimeDataWithZeroTime(date, config) {
  if (!date) return null;
  return convertTimeToServerStoredTimeData(dayjs(date).endOf('day').toDate(), config);
};
/**
 * Convert to YYYY-MM-DD
 * @param date Date
 * @param config
 * @returns
 */

export var transformDateStrToDayYear = function transformDateStrToDayYear(date) {
  return transformDateStrToTimeString(date, {
    format: 'YYYY-MM-DD'
  });
};
/**
 * Format chat message time with common relative-time rules in English.
 * today -> HH:mm:ss
 * yesterday -> Yesterday
 * day before yesterday -> The day before yesterday
 * within 7 days -> N days ago
 * within 1 month -> N weeks ago
 * within 1 year -> N months ago
 * otherwise -> N years ago
 */

export var formatChatTimeDisplay = function formatChatTimeDisplay(dateStr) {
  if (!dateStr) return '';
  var target = dayjs(dateStr);
  if (!target.isValid()) return '';
  var now = dayjs();

  if (target.isSame(now, 'day')) {
    return target.format('HH:mm:ss');
  }

  var diffDays = now.startOf('day').diff(target.startOf('day'), 'day');

  if (diffDays <= 0) {
    return target.format('HH:mm:ss');
  }

  if (diffDays === 1) {
    return 'Yesterday';
  }

  if (diffDays === 2) {
    return 'The day before yesterday';
  }

  if (diffDays < 7) {
    return "".concat(diffDays, " days ago");
  }

  var diffWeeks = Math.floor(diffDays / 7);

  if (diffDays < 30) {
    return "".concat(diffWeeks, " ").concat(diffWeeks === 1 ? 'week' : 'weeks', " ago");
  }

  var diffMonths = now.startOf('day').diff(target.startOf('day'), 'month');

  if (diffMonths < 12) {
    return "".concat(diffMonths, " ").concat(diffMonths === 1 ? 'month' : 'months', " ago");
  }

  var diffYears = now.startOf('day').diff(target.startOf('day'), 'year');
  return "".concat(diffYears, " ").concat(diffYears === 1 ? 'year' : 'years', " ago");
};
export var judgeTimeIsWithinSeconds = function judgeTimeIsWithinSeconds(utcStr, withinSeconds) {
  var serverTime = dayjs.utc(utcStr);
  var now = dayjs.utc();
  var isWithinSeconds = now.diff(serverTime, 'second') < withinSeconds && now.diff(serverTime, 'second') >= 0;
  return isWithinSeconds;
};
export var getServerDayjsDateKeepLocalTime = function getServerDayjsDateKeepLocalTime(value) {
  if (!value) return null;

  if (typeof value === 'string') {
    var normalizedValue = value.replace(/(Z|[+-]\d{2}:?\d{2})$/, '');
    return dayjs(normalizedValue).toDate();
  }

  return dayjs(value).toDate();
};